module.exports = "/_next/static/images/c0f6af87bd0aba0a58242009d1a39650-promo-hot-sale.jpg.webp";